import {Component, OnInit} from '@angular/core';
import { navItems } from '../../_nav';
import { ProfileService } from '../../services/profile.service';
import { ConstantService } from '../../services/constant.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.css']
})
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  public navItems = navItems;
  constructor(private constants: ConstantService) {
    	let userType = this.constants.getCookies().TYPE;
      if(userType !== 'admin') {
        this.navItems = _.filter(this.navItems , ['class', 'staff']);
      } else {
        this.navItems = _.filter(this.navItems , ['class', 'admin']);
      }
  }

  ngOnInit() {
  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }
}
